import { useState, useEffect } from "react";
import { X } from "lucide-react";

const MESSAGES = [
  "Recopilando tus 5 evaluaciones...",
  "Analizando indicadores clínicos...",
  "Cruzando datos físicos y nutricionales...",
  "Evaluando tu bienestar emocional...",
  "Identificando oportunidades de mejora...",
  "Diseñando tu plan personalizado...",
  "Construyendo recomendaciones por pilar...",
  "Optimizando tu reto semanal...",
  "Casi listo, dando los toques finales...",
];

// AI endpoint takes ~30-60s. We pace the bar to ~80s max so it never fully
// completes before the response arrives, and never feels stuck.
const TARGET_SECONDS = 80;

export function LoadingScreen({ onCancel }) {
  const [msgIdx, setMsgIdx] = useState(0);
  const [progress, setProgress] = useState(0);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const msgTimer = setInterval(
      () => setMsgIdx((i) => (i + 1) % MESSAGES.length),
      4500
    );
    const progTimer = setInterval(() => {
      setElapsed((s) => s + 0.25);
      setProgress((p) => Math.min(p + 100 / (TARGET_SECONDS * 4), 95));
    }, 250);
    return () => {
      clearInterval(msgTimer);
      clearInterval(progTimer);
    };
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 font-sans"
      style={{ background: "#FCFAEE" }}
    >
      <div
        className="text-center max-w-[340px] w-full"
        data-testid="recommendations-loading"
      >
        {/* Animated orb */}
        <div className="mx-auto mb-6" style={{ width: 96, height: 96 }}>
          <svg viewBox="0 0 80 80" style={{ width: "100%", height: "100%" }}>
            <circle cx="40" cy="40" r="35" fill="none" stroke="#E3F0F5" strokeWidth="4" />
            <circle
              cx="40"
              cy="40"
              r="35"
              fill="none"
              stroke="url(#tealGrad)"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="180"
              strokeDashoffset="60"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 40 40"
                to="360 40 40"
                dur="1.5s"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="40" cy="40" r="20" fill="#E3F0F5" opacity="0.5">
              <animate attributeName="r" values="18;22;18" dur="2s" repeatCount="indefinite" />
            </circle>
            <circle cx="40" cy="40" r="12" fill="url(#tealGrad)" opacity="0.85">
              <animate attributeName="r" values="10;14;10" dur="2s" repeatCount="indefinite" />
            </circle>
            <defs>
              <linearGradient id="tealGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#00628F" />
                <stop offset="50%" stopColor="#0080A0" />
                <stop offset="100%" stopColor="#2A9D8F" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <p
          className="text-sm font-semibold mb-1"
          style={{ color: "#2D2A24", minHeight: 20 }}
          data-testid="loading-message"
        >
          {MESSAGES[msgIdx]}
        </p>
        <p className="text-[11px] mb-4" style={{ color: "#71644C" }}>
          La IA está leyendo tu historia clínica completa
        </p>

        {/* Progress bar */}
        <div
          className="w-full rounded-full h-1.5 mb-2"
          style={{ background: "#E2D9CB" }}
        >
          <div
            className="h-1.5 rounded-full"
            style={{
              width: `${progress}%`,
              background: "linear-gradient(90deg, #00628F, #2A9D8F)",
              transition: "width 0.25s linear",
            }}
          />
        </div>
        <p className="text-[10px]" style={{ color: "#B5A998" }}>
          Esto puede tomar entre 30 y 60 segundos · {Math.floor(elapsed)}s
        </p>
        {elapsed > 25 && onCancel && (
          <button
            onClick={onCancel}
            data-testid="loading-cancel-btn"
            className="mt-4 inline-flex items-center gap-1 cursor-pointer"
            style={{
              border: "1px solid #E2D9CB",
              background: "transparent",
              color: "#71644C",
              fontSize: 11,
              fontWeight: 600,
              padding: "6px 14px",
              borderRadius: 8,
            }}
          >
            <X size={11} /> Cancelar
          </button>
        )}
      </div>
    </div>
  );
}
